/**
 * Timing constants for the Curation system
 */

export const TIMING = {
    /** Polling interval for background job status checks (ms) */
    JOB_POLL_INTERVAL_MS: 300,

    /** Duration to display success indicators (ms) */
    SUCCESS_INDICATOR_DURATION_MS: 2000,

    /** Debounce delay for input fields (ms) */
    INPUT_DEBOUNCE_MS: 300,

    /** Delay after successful auth before navigation (ms) */
    AUTH_SUCCESS_DELAY_MS: 1500,
} as const;
